import { reactive } from "vue";


export function getValue(list, key = 'value') {
    let value = reactive([]);
    for (let i = 0; i < list.length; i++) {
        value.push(list[i][key]);
    }
    return value;
}

export function getDict(list, key = 'name', value = 'value') {
    let dict = {};
    for (let i = 0; i < list.length; i++) {
        dict[list[i][key]] = parseFloat(list[i][value])
    }
    return dict;
}

export function getBar(list) {
    let bar = reactive([]);
    for (let i = 0; i < list.length; i++) {
        bar.push({
            No: list[i].No,
            diameter: list[i].diameter.value,
            space: list[i].space.value,
            num: list[i].num.value,
            data: (
                () => {
                    let data = reactive({});
                    for (let key in list[i].data) {
                        data[key] = list[i].data[key].value;
                    }
                    return data;
                }
            )(),
            singleLength: list[i].singleLength,
            length: parseFloat(list[i].length.toFixed(2)),
        });
    }
    return bar;
}


export function getForce(dict) {
    let force = {};
    let subKeys = ['fr', 'mr', 'fz', 'mz'];
    for (let key in dict) {
        let subDict = {};
        Object.keys(dict[key]).forEach(subKey => {
            if (subKeys.includes(subKey)) {
                subDict[subKey] = dict[key][subKey].value == 0 ? 0.001 : dict[key][subKey].value;
            }
        })
        force[key] = subDict;
    }
    return force;
}

export function getSoil(list) {
    let soil = [];
    for (let i = 0; i < list.length; i++) {
        let item = {}
        Object.keys(list[i]).forEach(key => {
            if (key !== 'index') {
                if (key === 'name' || key === 'index') {
                    item[key] = list[i][key].value;
                } else {
                    item[key] = parseFloat(list[i][key].value);
                }
            }
        })
        item['index'] = i
        soil.push(item);
    }
    return soil;
}